const TIME = {
  BASE: {
    SECOND: 1000,
    QUARTERMINUTE: 15 * 1000,
    HALFMINUTE: 30 * 1000,
    MINUTE: 60 * 1000,
  },
  MODULES: {
    META: {
      31536000000: 'YEAR', // 365 * 24 * 60 * 60 * 1000
      2678400000: 'MONTHS', // 31 * 24 * 60 * 60 * 1000
      86400000: 'DAYS', // 24 * 60 * 60 * 1000
      28800000: 'HOURS', // 8 * 60 * 60 * 1000
      3600000: 'HOURSMINUTES', // 60 * 60 * 1000
      120000: 'MINUTES', // 2 * 60 * 1000
      0: 'NOW', // 1000
    },
  },
};

export default TIME;



// WEBPACK FOOTER //
// ./src/const/time.js